<div class="CustomizationGroupContainer Flexbox Flexbox--column">
  @if (shouldShowNavBar()) {
    <div class="TopContainer Flexbox Justify--space-between" [class.Titleless]="isActiveViewTitleless()">
      <div class="LeftContainer ButtonContainer">
        @for (button of leftTitleButtons(); track $index) {
          @if (button.icon) {
            <button [ngStyle]="getStyle(button)" mat-icon-button (click)="button.onClick(button)">
              <mat-icon [ngStyle]="getIconStyle(button)">{{ button.icon }}</mat-icon>
            </button>
          } @else {
            <button mat-button (click)="button.onClick(button)">
              {{ button.label }}
            </button>
          }
        }
      </div>
      @if (!activeView().shouldHideTitle) {
        <div class="TitleContainer Flexbox Flexbox--column Justify--center Align--center">
          <h3 class="Title">{{ overrideTitle() ?? currentTitle() }}</h3>
          @if (subtitle()) {
            <span class="Subtitle">{{ subtitle() }}</span>
          }
        </div>
      }
      <div class="RightContainer ButtonContainer">
        @for (button of rightTitleButtons(); track $index) {
          @if (button.icon) {
            <button [ngStyle]="getStyle(button)" mat-icon-button (click)="button.onClick(button)">
              <mat-icon [ngStyle]="getIconStyle(button)">{{ button.icon }}</mat-icon>
            </button>
          } @else {
            <button mat-button (click)="button.onClick(button)">
              {{ button.label }}
            </button>
          }
        }
      </div>
    </div>
  }
  <div #viewContainer class="ViewContainer Grid">
    <ng-container appTestContent></ng-container>
  </div>
</div>
@if (activeBarItem()?.key !== 'favorites') {
  <app-toolbar [canRetailerAddToCart]="canRetailerAddToCart()"></app-toolbar>
}
